import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.701 17.6",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		"data-name": "Icon - Buy",
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M12.074 5.628a2.278 2.278 0 0 1-.248-2.928.455.455 0 0 0-.049-.586l-.993-.993a.913.913 0 0 0-1.289 0L1.119 9.495a.911.911 0 0 0 0 1.289l.993.994a.456.456 0 0 0 .587.049A2.279 2.279 0 0 1 5.878 15a.457.457 0 0 0 .049.587l.992.992a.911.911 0 0 0 1.289 0l8.378-8.377a.913.913 0 0 0 0-1.289l-.994-.993a.455.455 0 0 0-.586-.049 2.278 2.278 0 0 1-2.932-.243Z",
				"data-name": "Path 7228"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.417 11.224a.264.264 0 0 1-.373-.373",
				"data-name": "Path 7229"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.406 11.235a.264.264 0 0 0-.373-.373",
				"data-name": "Path 7230"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.85 8.657a.264.264 0 0 1-.369-.373",
				"data-name": "Path 7231"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.837 8.668a.264.264 0 1 0-.371-.374",
				"data-name": "Path 7232"
			})
		]
	})
});
export { SvgBuy as ReactComponent };
